const encodeUrlPath = (value) =>
  String(value || "")
    .split("/")
    .map((segment) => encodeURIComponent(segment))
    .join("/");

export const buildCustomTaskPdfUrl = (apiBase, pdfPath) => {
  const base = String(apiBase || "").replace(/\/+$/, "");
  const raw = String(pdfPath || "").trim();

  if (!raw) return "";
  if (/^https?:\/\//i.test(raw)) return raw;

  const normalizedPath = raw.replace(/\\/g, "/").replace(/^\/+/, "");

  if (
    normalizedPath.startsWith("task-files/") ||
    normalizedPath.startsWith("policy-files/") ||
    normalizedPath.startsWith("uploads/")
  ) {
    return `${base}/${encodeUrlPath(normalizedPath)}`;
  }

  return `${base}/task-files/${encodeUrlPath(normalizedPath)}`;
};
